import { render, staticRenderFns } from "./consultant-details-view.vue?vue&type=template&id=959277f2&scoped=true"
import script from "./consultant-details-view.vue?vue&type=script&lang=js"
export * from "./consultant-details-view.vue?vue&type=script&lang=js"
import style0 from "./consultant-details-view.vue?vue&type=style&index=0&id=959277f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959277f2",
  null
  
)

export default component.exports